import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "community component" }
const _hoisted_2 = { class: "section-header-div" }
const _hoisted_3 = { class: "community-content" }
const _hoisted_4 = { class: "discord-image" }
const _hoisted_5 = ["href"]
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "divider-container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "line-divider" }),
  /*#__PURE__*/_createElementVNode("div", { class: "default-text-contacts-grey-10" }, [
    /*#__PURE__*/_createElementVNode("span", null, "MEET THE COMMUNITY")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "line-divider" })
], -1)
const _hoisted_8 = { class: "user-grid-container" }
const _hoisted_9 = { class: "user-info" }
const _hoisted_10 = { class: "medium-text-grey-10 user-info-name" }
const _hoisted_11 = { class: "small-text-grey-10 user-info-role" }
const _hoisted_12 = { class: "community-profile-container" }
const _hoisted_13 = { class: "back-top-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sectionHeader = _resolveComponent("sectionHeader")!
  const _component_userImage = _resolveComponent("userImage")!
  const _component_communityProfile = _resolveComponent("communityProfile")!
  const _component_backTop = _resolveComponent("backTop")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_sectionHeader, {
        text: _ctx.sectionHeaderText,
        textColor: 'grey-10'
      }, null, 8, ["text"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("a", {
          href: _ctx.discordServerUrl,
          target: "_blank"
        }, [
          _createElementVNode("img", {
            class: "image",
            src: require('@/assets/images/lac-discord.png')
          }, null, 8, _hoisted_6)
        ], 8, _hoisted_5)
      ]),
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.randomList, (user, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "user-grid-element",
            key: index
          }, [
            _createVNode(_component_userImage, {
              user: user,
              onTogglenav: _ctx.updateUser
            }, null, 8, ["user", "onTogglenav"]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("p", _hoisted_10, _toDisplayString(user.name), 1),
              _createElementVNode("p", _hoisted_11, _toDisplayString(user.role), 1)
            ])
          ]))
        }), 128)),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_communityProfile, {
            open: _ctx.navOpen,
            user: _ctx.userSelected,
            onTogglenav: _cache[0] || (_cache[0] = ($event: any) => (_ctx.navOpen = !_ctx.navOpen))
          }, null, 8, ["open", "user"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createVNode(_component_backTop)
    ])
  ]))
}